import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="futuristic-bg" aria-hidden="true"></div>
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src="/logo_cropped.png" alt="YumeQuest" className="logo-img" />
          </div>
          <div className="nav-links">
            <a href="#services">Services</a>
            <a href="#projects">Projects</a>
            <a href="#about">About</a>
            <a href="#team">Team</a>
            <a href="#contact" className="nav-cta">Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content hero-flex">
          <div className="hero-left">
              <div className="hero-prefix-wrapper">
                <div className="hero-prefix">We build</div>
                <React.Suspense fallback={null}>
                  {React.createElement(require('./HeroSwitcher').default)}
                </React.Suspense>
              </div>
          </div>
          <div className="hero-right">
            <p className="hero-description">
              We publish and take contract work for:
              <br />Web, Game, Blockchain, Desktop, and Mobile Applications.
            </p>
            <div className="hero-cta">
              <a href="#contact" className="btn-primary">Get Started</a>
              <a href="#services" className="btn-secondary">Learn More</a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="section-container">
          <h2 className="section-title">What We Do</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🎮</div>
              <h3>Original Games</h3>
              <p>We develop and publish our own games, bringing unique interactive experiences to players worldwide.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💻</div>
              <h3>Software Products</h3>
              <p>Creating and publishing innovative software solutions that solve real-world problems.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">⚡</div>
              <h3>Contract Work</h3>
              <p>Selective freelancing and contract development for ambitious projects that align with our expertise.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Current Projects Section */}
      <section id="projects" className="projects">
        <div className="section-container">
          <h2 className="section-title">We are currently working on</h2>
          <div className="project-card-container">
            <div className="project-card">
              <div className="project-header">
                <h3 className="project-name">solfps.xyz</h3>
                <span className="project-badge">Hackathon Entry</span>
              </div>
              <p className="project-description">
                Entry for Solana Colosseum Cypherpunk Hackathon - Building innovative solutions on the Solana blockchain.
              </p>
              <div className="project-links">
                <a 
                  href="https://solfps.xyz" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="project-link project-website"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                  Visit Website
                </a>
                <a 
                  href="https://x.com/solfps_xyz" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="project-link project-twitter"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                  Follow on X
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="section-container">
          <h2 className="section-title">About YumeQuest</h2>
          <div className="about-content">
            <p className="about-text">
              YumeQuest is a private limited company registered in Estonia, 
              focused on creating and publishing our own games and software. 
              We also accept occasional contract work for select projects, 
              combining our expertise with a passion for innovation to deliver exceptional digital products.
            </p>
            <div className="about-stats">
              <div className="stat">
                <div className="stat-value">2025</div>
                <div className="stat-label">Founded</div>
              </div>
              <div className="stat">
                <div className="stat-value">Estonia</div>
                <div className="stat-label">Registered</div>
              </div>
              <div className="stat">
                <div className="stat-value">Global</div>
                <div className="stat-label">Reach</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="team">
        <div className="section-container">
          <h2 className="section-title">Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">
                <div className="avatar-placeholder">VE</div>
              </div>
              <h3 className="member-name">Victor Mak</h3>
              <p className="member-role">Founder</p>
              <div className="social-links">
                <a 
                  href="https://www.linkedin.com/in/victorevolves" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link linkedin-link"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                  LinkedIn
                </a>
                <a 
                  href="https://x.com/victorevolves" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link x-link"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                  X (Twitter)
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="section-container">
          <h2 className="section-title">Let's Work Together</h2>
          <p className="contact-description">
            Interested in our products or have a contract opportunity? We'd love to hear from you.
          </p>
          <a href="mailto:hello@yumequest.com" className="btn-primary">Contact Us</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand">
              <img src="/logo_cropped.png" alt="YumeQuest" className="footer-logo" />
            </div>
            
            <div className="footer-columns">
              <div className="footer-column">
                <h4 className="footer-heading">Company</h4>
                <ul className="footer-links">
                  <li><a href="#about">About</a></li>
                  <li><a href="#services">Services</a></li>
                  <li><a href="#projects">Projects</a></li>
                  <li><a href="#team">Team</a></li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h4 className="footer-heading">Contact</h4>
                <ul className="footer-links">
                  <li><a href="mailto:contact@yumequest.xyz">contact@yumequest.xyz</a></li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h4 className="footer-heading">Follow Us</h4>
                <div className="footer-social-links">
                  <a 
                    href="https://x.com/yumequestxyz" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    X (Twitter)
                  </a>
                  <a 
                    href="https://www.instagram.com/yumequest/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p className="footer-copyright">© 2025 YumeQuest OÜ. All rights reserved.</p>
            <p className="footer-legal">
              Registered in the Estonian Business Register (Äriregister) with Registry Code 17347624. 
              Harju maakond, Tallinn, Kesklinna linnaosa, Pärnu mnt 105, 11312
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
